(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405,4005],{

/***/ 75557:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(53678);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 64005:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ useModalData; }
/* harmony export */ });
/* harmony import */ var _ebay_nice_modal_react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25362);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _lib_hooks_useAdminMode__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67964);




var useModalData = function() {
    var activeModals = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(_ebay_nice_modal_react__WEBPACK_IMPORTED_MODULE_0__/* ["default"].NiceModalContext */ .ZP.NiceModalContext);
    var areThereActiveModals = Object.keys(activeModals).length > 0;
    var isAdminMode = (0,_lib_hooks_useAdminMode__WEBPACK_IMPORTED_MODULE_3__/* .useAdminMode */ .p)();
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        router.beforePopState(function() {
            // when a user uses browser navigation, this hook will go through each active modal and remove them using their id
            Object.values(activeModals).forEach(function(i) {
                return _ebay_nice_modal_react__WEBPACK_IMPORTED_MODULE_0__/* ["default"].remove */ .ZP.remove(i.id);
            });
            // if this was return false, it would cancel the navigation request
            return true;
        });
    }, [
        router
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (areThereActiveModals && !isAdminMode) {
            document.body.classList.add("stop-scroll");
        } else {
            document.body.classList.remove("stop-scroll");
        }
        return function() {
            document.body.classList.remove("stop-scroll");
        };
    }, [
        areThereActiveModals,
        isAdminMode
    ]);
    return areThereActiveModals;
};


/***/ }),

/***/ 53678:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _ebay_nice_modal_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25362);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var react_awesome_reveal__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(81277);
/* harmony import */ var react_intersection_observer__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(42708);
/* harmony import */ var _components_atomic_PageMetaData__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1429);
/* harmony import */ var _components_styleguide_Button__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96732);
/* harmony import */ var _components_styleguide_Homepage_Sections_RecentlyViewed__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8947);
/* harmony import */ var _components_styleguide_Homepage_Sections_TopDeals__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(24778);
/* harmony import */ var _components_styleguide_Link__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(63383);
/* harmony import */ var _components_views_HomePage_HeroBackground__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(8465);
/* harmony import */ var _components_views_HomePage_Search__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(17836);
/* harmony import */ var _lib_constants__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(99280);
/* harmony import */ var _lib_hooks_useAdminMode__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(67964);
/* harmony import */ var _lib_hooks_useModalData__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(64005);
/* harmony import */ var _lib_routes__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(7158);
/* harmony import */ var _lib_utilities_system__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(70591);
/* harmony import */ var _types_system__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(16693);



















var CollectionsCarousel = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 2415).then(__webpack_require__.bind(__webpack_require__, 72415));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(72415)
            ];
        }
    }
});
var Brands = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 2607).then(__webpack_require__.bind(__webpack_require__, 32607));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(32607)
            ];
        }
    }
});
var Grid = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(8456), __webpack_require__.e(6388), __webpack_require__.e(5492)]).then(__webpack_require__.bind(__webpack_require__, 15492));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(15492)
            ];
        }
    }
});
var Cards = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(8456), __webpack_require__.e(2136)]).then(__webpack_require__.bind(__webpack_require__, 92136));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(92136)
            ];
        }
    }
});
var LocoScore = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(2345), __webpack_require__.e(3646)]).then(__webpack_require__.bind(__webpack_require__, 3646));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(3646)
            ];
        }
    }
});
var LocoAi = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 6636).then(__webpack_require__.bind(__webpack_require__, 46636));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(46636)
            ];
        }
    }
});
var HowDoesItWork = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 8420).then(__webpack_require__.bind(__webpack_require__, 88420));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(88420)
            ];
        }
    }
});
var Faqs = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(8456), __webpack_require__.e(1876), __webpack_require__.e(7702)]).then(__webpack_require__.bind(__webpack_require__, 47702));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(47702)
            ];
        }
    }
});
var ReferAFriend = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 4688).then(__webpack_require__.bind(__webpack_require__, 4688));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(4688)
            ];
        }
    }
});
var Testimonials = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(6066), __webpack_require__.e(5892)]).then(__webpack_require__.bind(__webpack_require__, 15892));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(15892)
            ];
        }
    }
});
var NewsletterFormModal = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(2580), __webpack_require__.e(6310), __webpack_require__.e(1600), __webpack_require__.e(4435), __webpack_require__.e(6006)]).then(__webpack_require__.bind(__webpack_require__, 76006));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(76006)
            ];
        }
    }
});
var HomePage = function(param) {
    var heroVehicle = param.heroVehicle, faqList = param.faqList, dealList = param.dealList, secondDealList = param.secondDealList, dealCount = param.dealCount;
    var areThereActiveModals = (0,_lib_hooks_useModalData__WEBPACK_IMPORTED_MODULE_13__/* .useModalData */ .U)();
    var isAdminMode = (0,_lib_hooks_useAdminMode__WEBPACK_IMPORTED_MODULE_12__/* .useAdminMode */ .p)();
    var ref = (0,react_intersection_observer__WEBPACK_IMPORTED_MODULE_17__/* .useInView */ .YD)(), ref1 = ref.ref, inView = ref.inView;
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), isVans = ref2[0];
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        if ((0,_lib_utilities_system__WEBPACK_IMPORTED_MODULE_15__/* .storageAvailable */ .oZ)("localStorage") && !areThereActiveModals && inView && !window.localStorage.getItem(_lib_constants__WEBPACK_IMPORTED_MODULE_11__/* .constants.localStorageKey.newsletterPopup */ ._G.localStorageKey.newsletterPopup) && !isAdminMode) {
            _ebay_nice_modal_react__WEBPACK_IMPORTED_MODULE_1__/* ["default"].show */ .ZP.show(NewsletterFormModal);
        }
    }, [
        areThereActiveModals,
        inView,
        isAdminMode
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("main", {
        className: "container-fluid container--content-homepage is-cars",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_atomic_PageMetaData__WEBPACK_IMPORTED_MODULE_4__/* .PageMetaData */ .S, {
                title: _lib_constants__WEBPACK_IMPORTED_MODULE_11__/* .constants.metaData.title */ ._G.metaData.title,
                description: _lib_constants__WEBPACK_IMPORTED_MODULE_11__/* .constants.metaData.description */ ._G.metaData.description,
                pageUrl: _lib_routes__WEBPACK_IMPORTED_MODULE_14__/* .ROUTES.homePage.url */ .Z.homePage.url
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_awesome_reveal__WEBPACK_IMPORTED_MODULE_18__/* .Fade */ .pT, {
                cascade: true,
                damping: 0.1,
                triggerOnce: true,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_views_HomePage_HeroBackground__WEBPACK_IMPORTED_MODULE_9__/* .HeroBackground */ .M, {
                    isVans: isVans,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_views_HomePage_Search__WEBPACK_IMPORTED_MODULE_10__/* .Search */ .o, {
                        isVans: isVans,
                        popularSearchesVisibility: "all",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_styleguide_Link__WEBPACK_IMPORTED_MODULE_8__/* .InternalLink */ .h, {
                            hasBackground: true,
                            hasPadding: true,
                            hasTransition: true,
                            href: _lib_routes__WEBPACK_IMPORTED_MODULE_14__/* .ROUTES.carSearchPage.url */ .Z.carSearchPage.url,
                            icon: "Search",
                            theme: _types_system__WEBPACK_IMPORTED_MODULE_16__/* .Theme.dark */ .Q2.dark,
                            hierarchy: _components_styleguide_Button__WEBPACK_IMPORTED_MODULE_5__/* .ButtonHierarchy.Filled */ .B.Filled,
                            size: _types_system__WEBPACK_IMPORTED_MODULE_16__/* .Size.Large */ .$u.Large,
                            children: "Search deals"
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_styleguide_Homepage_Sections_RecentlyViewed__WEBPACK_IMPORTED_MODULE_6__/* .RecentlyViewed */ .H, {
                isVans: isVans
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Brands, {
                isVans: isVans
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_styleguide_Homepage_Sections_TopDeals__WEBPACK_IMPORTED_MODULE_7__/* .TopDeals */ .UI, {
                dealList: dealList,
                isVans: isVans
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                ref: ref1
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LocoAi, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CollectionsCarousel, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_styleguide_Homepage_Sections_TopDeals__WEBPACK_IMPORTED_MODULE_7__/* .TopDeals */ .UI, {
                dealList: secondDealList,
                isVans: isVans,
                type: _components_styleguide_Homepage_Sections_TopDeals__WEBPACK_IMPORTED_MODULE_7__/* .DEALS_UNDER_300 */ .a
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Grid, {
                isVans: isVans,
                dealCount: dealCount
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LocoScore, {
                deal: heroVehicle,
                isVans: isVans
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Cards, {
                isVans: isVans,
                dealCount: dealCount
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Testimonials, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(HowDoesItWork, {
                isVans: isVans
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Faqs, {
                faqList: faqList
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ReferAFriend, {
                isVans: isVans
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (HomePage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2302,1852,5675,4660,8611,638,1429,3052,3680,9774,2888,179], function() { return __webpack_exec__(75557); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);